let splashes;

export const splashInit = (force = false) => {
    splashes = document.querySelectorAll(".splash");

    if (
        (!sessionStorage.getItem("splashed") &&
            document.querySelector("body").classList.contains("home")) ||
        force
    ) {
        noscroll();
        splashes.forEach((splash) => {
            splash.classList.add("splash-is-on");
        });
        sessionStorage.setItem("splashed", true);
    } else {
        // sessionStorage.removeItem("splashed");
        document.body.classList.add("splashed");
        splashes.forEach((splash) => {
            splash.classList.remove("splash-is-on");
            splash.classList.add("splashed");
        });
    }

    function noscroll() {
        document.addEventListener("touchmove", disableScroll, {
            passive: false,
        });
        document.addEventListener("mousewheel", disableScroll, {
            passive: false,
        });

        setTimeout(() => {
            document.removeEventListener("touchmove", disableScroll, {
                passive: false,
            });
            document.removeEventListener("mousewheel", disableScroll, {
                passive: false,
            });
            document.body.classList.add("splashed");
            splashes.forEach((splash) => {
                splash.classList.add("splashed");
            });
        }, 4000);
    }

    function disableScroll(event) {
        event.preventDefault();
    }
};

window.addEventListener("load", () => {
    splashInit();
});

window.splashInit = () => {
    document.body.classList.remove("splashed");
    splashes.forEach((splash) => {
        splash.classList.remove("splashed");
        splash.classList.remove("splash-is-on");
    });
    setTimeout(() => {
        splashInit(true);
    }, 300);
};
